var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.133v10.133H0zM0 13.933h10.133v10.133H0zM0 27.867h10.133V38H0zM13.933 0h10.133v10.133H13.933zM13.933 13.933h10.133v10.133H13.933zM13.933 27.867h10.133V38H13.933zM27.867 0H38v10.133H27.867zM27.867 13.933H38v10.133H27.867zM27.867 27.867H38V38H27.867z"
  }))));
};
export default SvgGallery;